import React, { FC } from "react";
import {
  Box,
  Button,
  Container,
  Dialog,
  Flex,
  Grid,
  Text,
} from "@radix-ui/themes";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import i18next from "i18next";
import { PrivacyPolicy } from "@/pages/PrivacyPolicy/PrivacyPolicy";
import { TermsOfUse } from "@/pages/TermsOfUse/TermsOfUse";

const Footer: FC = (): JSX.Element => {
  const isNotBG = brand.brandValue !== "BG" && brand.brandValue !== "DBG";
  const isLEGO = brand.brandValue === "LEGO";

  return (
    <Box>
      <Container pt="8" px={{ initial: "4", md: "2", xl: "0" }}>
        <Grid columns={{ initial: "1", lg: "4" }}>
          <Box></Box>
        </Grid>
        <Box py="3">
          <Flex
            direction={{ initial: "column", lg: "row" }}
            justify={{ initial: "center", lg: "between" }}
            align="center"
          >
            <Text size="2" color="gray">
              Copyright &copy;
              {isNotBG ? (
                <> 2023 - {new Date().getFullYear()}</>
              ) : (
                new Date().getFullYear()
              )}
              {isNotBG ? (
                <>
                  {isLEGO ? (
                    <>
                      {" "}
                      iPlay ApS for {brand.name} in cooperation with Elgiganten
                    </>
                  ) : (
                    <> iPlay ApS for {brand.name}</>
                  )}
                </>
              ) : (
                brand.name
              )}
            </Text>
            <Box>
              {/* Terms of Use */}
              <Dialog.Root>
                <Dialog.Trigger>
                  <Text
                    size="2"
                    color="gray"
                    style={{ cursor: "var(--cursor-link)" }}
                  >
                    {i18next.t("auth.terms.2")}
                  </Text>
                </Dialog.Trigger>

                <Dialog.Content size="4">
                  <Dialog.Title>{i18next.t("auth.terms.2")}</Dialog.Title>

                  <Box>
                    <TermsOfUse />
                  </Box>

                  <Flex gap="3" mt="4" justify="end">
                    <Dialog.Close>
                      <Button variant="soft" color="gray">
                        Close
                      </Button>
                    </Dialog.Close>
                  </Flex>
                </Dialog.Content>
              </Dialog.Root>
              <Text size="2" color="gray">
                {" "}
                {i18next.t("auth.terms.3")}{" "}
              </Text>
              {/* Privacy Policy */}
              <Dialog.Root>
                <Dialog.Trigger>
                  <Text
                    size="2"
                    color="gray"
                    style={{ cursor: "var(--cursor-link)" }}
                  >
                    {i18next.t("auth.terms.4")}
                  </Text>
                </Dialog.Trigger>

                <Dialog.Content size="4">
                  <Dialog.Title>{i18next.t("auth.terms.4")}</Dialog.Title>

                  <Box>
                    <PrivacyPolicy />
                  </Box>

                  <Flex gap="3" mt="4" justify="end">
                    <Dialog.Close>
                      <Button variant="soft" color="gray">
                        Close
                      </Button>
                    </Dialog.Close>
                  </Flex>
                </Dialog.Content>
              </Dialog.Root>{" "}
            </Box>
          </Flex>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
